export const tagsRel ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "faturamentoBrutoDolar", label: "Faturamento Bruto em Dólar ($)"},
        { key: "faturamentoBrutoReal", label: "Faturamento Bruto em Real (R$)"},
        { key: "capitalSocial", label: "Capital Social"},
        { key: "observacoes", label: "Observações"},
        { key: "createdAt", label: "Data de Criação"},
        { key: "updatedAt", label: "Data de Atualização"},
    ]
}
export const tagsRelProd ={
    headers:[
        { key: "cnpj", label: "CNPJ"},
        { key: "empresa", label: "Empresa"},
        { key: "ano", label: "Ano"},
        { key: "produto", label: "Produto"},
        { key: "producaoBruta", label: "ROM(ton)"},
        { key: "producaoConcentrado", label: "Concentrado(ton)"},
        { key: "unidades", label: "Plantas"},
        { key: "producaoCreatedAt", label: "Inserido"},
        { key: "producaoUpdatedAt", label: "Atualizado"},
    ]
}